export default "__VITE_ASSET__BEeFZU1D__"